import {Component, OnInit, ViewChild} from '@angular/core';
import {MessageService} from "../../utils/message/message.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {LanguagePickerService} from "../../utils/language-picker/language-picker.service";
import {ManufactureApiService} from "../../api/manufacture-api.service";
import {ProductionItem} from "../../model/manufacture/item";
import {MatSort, Sort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";

@Component({
  selector: 'app-manufacturing-page',
  templateUrl: './manufacturing-page.component.html',
  styleUrls: ['./manufacturing-page.component.scss']
})
export class ManufacturingPageComponent implements OnInit {
  lensGroups: String[];
  materials: String[];
  countries: String[];

  selectedLensGroups: string[];
  selectedMaterials: string[];
  selectedCountries: string[];
  selectedPrism: boolean = false;
  selectedDays: number;

  selectedFile: File;

  originalItems: ProductionItem[];
  filteredItems: ProductionItem[];
  tableItems: any;
  displayedColumns: string[] = ['lensGroup', 'material', 'country', 'prism', 'days'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('itemPaginator') itemPaginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private messageService: MessageService,
    private languagePickerService: LanguagePickerService,
    private manufactureApi: ManufactureApiService,
  ) {
  }

  ngOnInit() {
    this.manufactureApi.getOptions().subscribe(options => {
      this.lensGroups = options[0];
      this.materials = options[1];
      this.countries = options[2];
    });
    this.fetch();
  }

  public onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    if (this.selectedFile != null && this.selectedFile != undefined) {
      this.parse();
    }
  }

  goBack() {
    this.router.navigate(['/sa/home'])
  }

  checkSelected() {
    return this.selectedLensGroups && this.selectedMaterials && this.selectedCountries && this.selectedDays;
  }

  pushSelected() {
    let lensGroups: string[] = this.selectedLensGroups;
    let materials: string[] = this.selectedMaterials;
    let countries: string[] = this.selectedCountries;

    let items: Array<ProductionItem> = [];
    lensGroups.forEach(lensGroup => {
      materials.forEach(material => {
        countries.forEach(country => {
          let item: ProductionItem = {lensGroup: lensGroup, material: material, country: country, prism: this.selectedPrism, days: this.selectedDays};
          items.push(item);
        });
      });
    });

    this.manufactureApi.push(items).subscribe(response => {
      if (response.success) {
        this.messageService.info("Items were successfully updated.");
        this.fetch();
      } else {
        this.messageService.error("Trouble occurred while updating items.");
      }
    });
  }

  parse() {
    const days = new FormData();
    days.append('days', this.selectedFile, this.selectedFile.name);
    this.manufactureApi.parse(days).subscribe(response => {
      if (response.success) {
        this.messageService.info("Off-days file was parsed successfully");
      } else {
        console.log(response.httpError);
        this.messageService.error("Failed to parse off-days file");
      }
    });
  }

  fetch() {
    this.manufactureApi.getAll().subscribe(items => {
      this.originalItems = this.filteredItems = items;
      this.tableItems = new MatTableDataSource(items);
      if (this.tableItems != undefined) {
        this.tableItems.sort = this.sort;
        this.tableItems.paginator = this.itemPaginator;
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.filteredItems.slice();
    if (!sort.active || sort.direction === '') {
      this.filteredItems = data;
      return;
    }

    this.filteredItems = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'lensGroup': return compare(a.lensGroup, b.lensGroup, isAsc);
        case 'material': return compare(a.material, b.material, isAsc);
        case 'country': return compare(a.country, b.country, isAsc);
        case 'prism': return compare(a.prism, b.prism, isAsc);
        case 'days': return compare(a.days, b.days, isAsc);
        default: return 0;
      }
    });
    this.tableItems = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  private reInitTableSortPaginator() {
    this.tableItems.sort = this.sort;
    this.tableItems.paginator = this.itemPaginator;
  }

}

function compare(a: number | string | boolean, b: number | string | boolean, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
